webpackJsonp([123],{

/***/ 1959:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function isSelected(id) {
	this.$emit('selected-icon', id);
	return !!this.answersSelected.find(function (a) {
		return a === id;
	});
}

function handlerAnswersSelected(newVal, oldVal) {
	if (newVal === 0) {
		this.$store.commit('UPDATE_POLL_PROGRESS', -1);
	}
	if (oldVal === 0) {
		this.$store.commit('UPDATE_POLL_PROGRESS', 1);
	}
}

function data() {
	return {
		answersSelected: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'check-button-template',
	data: data,
	methods: {
		handlerAnswersSelected: handlerAnswersSelected,
		isSelected: isSelected
	},
	props: {
		answers: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		questionId: Number
	},
	watch: {
		'answersSelected.length': handlerAnswersSelected
	}
});

/***/ }),

/***/ 2515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_check_button_template_vue__ = __webpack_require__(1959);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e6273a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_check_button_template_vue__ = __webpack_require__(2516);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_check_button_template_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e6273a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_check_button_template_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2516:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-template"},_vm._l((_vm.answers),function(answer){return _c('div',{key:answer.id,staticClass:"answer"},[_c('label',{class:[ _vm.isSelected(answer.id) ? 'answer-selected' : 'answer-text' ],attrs:{"for":("answer-" + _vm.questionId + "-" + (answer.id))}},[_vm._v("\n\t\t\t"+_vm._s(answer.name)+"\n\t\t")]),_vm._v(" "),_c('v-checkbox',{attrs:{"id":("answer-" + _vm.questionId + "-" + (answer.id)),"value":answer.id},model:{value:(_vm.answersSelected),callback:function ($$v) {_vm.answersSelected=$$v},expression:"answersSelected"}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/123.4717d3647dd549e93694.js